/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'in': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M967.1 0H398.2c-31.4 0-56.9 25.5-56.9 56.9v170.7h113.8V113.8h455.1v796.4H455.1V796.4H341.3v170.7c0 31.4 25.5 56.9 56.9 56.9h568.9c31.4 0 56.9-25.5 56.9-56.9V56.9C1024 25.5 998.5 0 967.1 0z"/><path pid="1" d="M500.2 670.9c-22.2 22.1-22.2 58.3 0 80.5 22.2 22.2 58.3 22.2 80.5 0l199.1-199.1c22.2-22.2 22.2-58.3 0-80.5L580.7 272.6c-22.2-22.2-58.2-22.2-80.5 0-22.2 22.2-22.2 58.4 0 80.5l102 102H56.9C25.5 455.1 0 480.6 0 512s25.5 56.9 56.9 56.9h545.3l-102 102z"/>'
  }
})
